import { LeaderboardUser } from "model/Leaderboard/User/LeaderboardUser";
import { RootState } from "app/store";

export const selectLeaderboard = (state: RootState, id: string | undefined) => {
  if (!id) {
    return undefined;
  }

  return state.leaderboard.leaderboards[id];
};

export const selectLeaderboardUser = (
  state: RootState,
  id: string,
  uid: string
): LeaderboardUser | undefined => {
  const leaderboard = selectLeaderboard(state, id);
  return !!leaderboard ? leaderboard.users[uid] : undefined;
};

export const selectFetchingLeaderboardUsers = (state: RootState) => {
  return state.leaderboard.fetchingLeaderboardUsers;
};
